import { FormattedOption } from 'types/dictionaries';

const formatAndOrderData = (
  data: FormattedOption[],
  order: string[]
): FormattedOption[] => {
  return [...data].sort((a, b) => {
    const valueA = typeof a.value === 'string' ? a.value : '';
    const valueB = typeof b.value === 'string' ? b.value : '';

    const indexA = order.indexOf(valueA);
    const indexB = order.indexOf(valueB);

    return (
      (indexA !== -1 ? indexA : Infinity) -
        (indexB !== -1 ? indexB : Infinity) || valueA.localeCompare(valueB)
    );
  });
};

export default formatAndOrderData;
